import React, { Component } from "react";
import ZPartner01GrabHeader from "./ZPartner01GrabHeader";
import ZPartner01GrabFooter from "./ZPartner01GrabFooter";

export class ZPartner01MemberSigninSuccess extends Component {
    static displayName = ZPartner01MemberSigninSuccess.name;

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        const links = [
            "https://fonts.googleapis.com/css?family=Lato:300&text=1234567890,.-",
            "/css/style.css",
            "/css/style-sr.css"
        ];

        links.forEach(href => {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = href;
            document.head.appendChild(link);
        });
    }    
    
    render() {        
        return (
            <>
                <ZPartner01GrabHeader />

                <main id="main">
                    <section className="top-sr-bg bg-gray1">
                        <div className="container">
                            <div className="row justify-content-between">
                                <div className="col col-md-6">
                                    <h1 className="text-headpage text-white mb-0 pt-3 pb-3 ">
                                        <span className="d-none">Starbucks® Rewards</span>
                                        <img src="media/rewards/starbucks-rewards-logo-2.png" alt="Starbucks® Rewards" className="img-fluid" style={{ maxWidth: '158px' }} />
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="section-sign-in overflow-hidden pb-5">
                        <div className="container p-1 p-md-0">                            
                            <div className="row justify-content-center px-1 px-md-5">
                                <div className="col-md-6 mb-3 pt-3">
                                    <div className="py-5 p-4 box-sign-in">
                                        <p className="mb4">
                                            <strong>ผูกบัญชีสำเร็จ</strong><br />
                                            ไปที่หน้าสรุปคำสั่งซื้อจะมีเครื่องหมายถูกสีเขียวปรากฏอยู่ที่หลังคำว่า <strong>“Membership”</strong>
                                        </p>
                                        <p>
                                            <strong>Success</strong><br />
                                            Green check mark will appear after <strong>"Membership"</strong> on Order Summary page.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                    </section>
                </main>

                <ZPartner01GrabFooter />
            </>            
        );
    }
}
